import { render, staticRenderFns } from "./poiSearchResult.vue?vue&type=template&id=551a5755&scoped=true"
import script from "./poiSearchResult.vue?vue&type=script&lang=js"
export * from "./poiSearchResult.vue?vue&type=script&lang=js"
import style0 from "./poiSearchResult.vue?vue&type=style&index=0&id=551a5755&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a5755",
  null
  
)

export default component.exports